import { vs2jen2LimitedReleasesListConstants } from "../_redux-constants";
import { vs2jen2LimitedReleasesListService } from "../../_services";

function getVs2jen2LimitedReleasesList(queryParams) {
  function getVs2jen2LimitedReleasesListLoad() {
    return {
      type: vs2jen2LimitedReleasesListConstants.VS2JEN2_LIMITED_RELEASES_LIST_LOADING,
    };
  }
  function getVs2jen2LimitedReleasesListSuccess(data) {
    return {
      type: vs2jen2LimitedReleasesListConstants.VS2JEN2_LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getVs2jen2LimitedReleasesListFailure(error) {
    return {
      type: vs2jen2LimitedReleasesListConstants.VS2JEN2_LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2jen2LimitedReleasesListLoad());
    return vs2jen2LimitedReleasesListService
      .getVs2jen2LimitedReleasesList(queryParams)
      .then(
        (data) => {
          dispatch(getVs2jen2LimitedReleasesListSuccess(data));
        },
        (error) => {
          dispatch(getVs2jen2LimitedReleasesListFailure(error?.toString()));
        }
      );
  };
}

export const vs2jen2LimitedReleasesListActions = {
  getVs2jen2LimitedReleasesList,
};
